module.exports = __webpack_public_path__ + "img/bn0715.4be5da24.png";